import { Button } from '@mui/material';
import { RedTheme } from 'common/global';
import { useScreen } from 'common/hooks/useScreen';
import { labels } from 'common/global/constants';
import { AdminViewGetAllerts, MyTeamsPerformaceGetAlerts } from 'TAP/redux/actions/alertAction';
import { useDispatch } from 'react-redux';

export const CustomSetAlertButton = ({ isAdmin = false, clickHandler, isOpen, disabled = false, buttonLabelText = '' }) => {
  let redtheme = RedTheme;
  const screen = useScreen();
  const dispatch = useDispatch();

  const fetchAlerts = () => {
    if (isAdmin) {
      dispatch(AdminViewGetAllerts());
    } else {
      dispatch(MyTeamsPerformaceGetAlerts());
    }
  };

  const handleClick = () => {
    clickHandler(!isOpen);
    if (buttonLabelText) {
      fetchAlerts();
    }
  };

  return (
    <Button
      sx={{
        paddingTop: '7px',
        width: screen.isTablet ? '110px' : '120px',
        height: '32px',
        borderRadius: '8px',
        marginTop: '15px',
        marginLeft: screen.resolveStyles({
          mobile: '0px',
          tablet: '10px',
          desktop: '20px',
        }),
        color: redtheme.palette.background.default,
        bgcolor: redtheme.palette.text.primary,
        fontSize: '16px',
        lineHeight: '16px',
        textTransform: 'capitalize',
        fontWeight: 500,
        fontFamily: '"JohnsonText-Medium"',
        '&:hover': {
          backgroundColor: redtheme.palette.text.primary,
          color: redtheme.palette.background.default,
        },
      }}
      onClick={handleClick}
      variant='contained'
      disabled={disabled}
    >
      {buttonLabelText ? buttonLabelText : labels.setAlert}
    </Button>
  );
};
